module.exports = __webpack_public_path__ + "img/monitorbox09.5ccb71b6.jpg";